import type { JSX } from 'react'

import { TopNumber5SC } from './TopNumbers.styled'

export const Top5 = (): JSX.Element => (
  <TopNumber5SC
    width='130'
    height='191'
    viewBox='0 0 130 191'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M70.3942 69.9703C81.9018 69.9703 92.1508 72.5818 101.141 77.8048C110.311 83.0278 117.414 90.322 122.448 99.6874C127.483 108.873 130 119.139 130 130.485C130 142.552 127.033 153.178 121.1 162.363C115.346 171.369 107.165 178.393 96.556 183.436C85.9474 188.479 73.6307 191 59.6058 191C48.6376 191 37.9391 189.559 27.5104 186.678C17.2614 183.616 8.09129 179.293 0 173.71V143.993H1.07884C8.81051 150.297 17.9806 155.43 28.5892 159.392C39.1978 163.354 49.3568 165.335 59.0664 165.335C71.2932 165.335 81.1826 162.093 88.7344 155.61C96.2863 148.946 100.062 140.301 100.062 129.675C100.062 119.769 96.7358 111.664 90.083 105.361C83.61 98.8769 75.0692 95.6351 64.4606 95.6351C51.3347 95.6351 38.9281 100.408 27.2407 109.953H26.1618L5.93361 102.659V101.308L17.8008 0H121.1V26.2051H41.805L35.6017 78.6153C46.7497 72.852 58.3472 69.9703 70.3942 69.9703Z'
      fill='url(#paint0_linear_5096_100040)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100040'
        x1='-18.61'
        y1='-0.236372'
        x2='168.047'
        y2='166.884'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber5SC>
)
